import axios from "axios";
import { Message } from "element-ui";
// console.log(process.env.VUE_APP_ENV_MODE);
if (process.env.VUE_APP_ENV_MODE === "development") 
{
  axios.defaults.baseURL = "/api";
} 
else if(process.env.VUE_APP_ENV_MODE === "local")
{
  axios.defaults.baseURL =
    "https://dlut.mools.net/lims/api/laravel/public/index.php";
}
else
{
  axios.defaults.baseURL =
    "https://www.mools.net/lims/api/laravel/public/index.php";
}


// 10s超时
axios.defaults.timeout = 10000;

// post头
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

// 请求拦截
axios.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.error(error);
  }
);

// 响应拦截
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      if (response.data && response.data.code > 0) {
        return Promise.resolve(response);
      } else {
        // Message.error(response.data.msg || "操作失败");
        return Promise.reject(response);
      }
    } else {
      Message.error("网络异常");
      return Promise.reject(response);
    }
  },
  error => {
    Message.error("网络异常");
    return Promise.reject(error.response);
  }
);
